// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.css-dev-only-do-not-override-xepvsj).ant-tabs-left
  > .ant-tabs-nav
  .ant-tabs-tab {
  text-align: start;
}
.chat-container-tabs .ant-tabs .ant-tabs-ink-bar {
  position: absolute;
  background: #d2042d;
  pointer-events: none;
  width: 7px;
  margin-right: 99%;
}

.chat-container-tabs .ant-tabs-tab-active {
  background-color: #ffe6eb;
  width: 310px;
}
.search-input-chat-campaigns {
  height: 55px !important;
}

.in-app-chat-campaign {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  font-family: "Roboto";
}
.chat-timestamp {
  display: flex;
  justify-content: flex-end;
}

.chat-products-count {
  color: #606060;
  font-family: "Roboto";
}
.chat-product-name {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  font-family: "Roboto";
}
.product-buyer-name {
  color: #717171;
  font-weight: 400;
  font-family: "Roboto";
  font-size: 13px;
}
.chat-campaign-name {
  font-size: 18px !important;
  font-weight: 500;
  color: #000000;
  font-family: "Roboto";
}
.select-prodcut-sub-text {
  font-size: 16px;
  color: #6e6e6e;
  font-family: "Roboto";
  font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/seller-chat-components/CampaignsChatList.css"],"names":[],"mappings":"AAAA;;;EAGE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB","sourcesContent":[":where(.css-dev-only-do-not-override-xepvsj).ant-tabs-left\n  > .ant-tabs-nav\n  .ant-tabs-tab {\n  text-align: start;\n}\n.chat-container-tabs .ant-tabs .ant-tabs-ink-bar {\n  position: absolute;\n  background: #d2042d;\n  pointer-events: none;\n  width: 7px;\n  margin-right: 99%;\n}\n\n.chat-container-tabs .ant-tabs-tab-active {\n  background-color: #ffe6eb;\n  width: 310px;\n}\n.search-input-chat-campaigns {\n  height: 55px !important;\n}\n\n.in-app-chat-campaign {\n  font-size: 16px;\n  font-weight: 500;\n  color: #000000;\n  font-family: \"Roboto\";\n}\n.chat-timestamp {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.chat-products-count {\n  color: #606060;\n  font-family: \"Roboto\";\n}\n.chat-product-name {\n  font-size: 16px;\n  font-weight: 500;\n  color: #000000;\n  font-family: \"Roboto\";\n}\n.product-buyer-name {\n  color: #717171;\n  font-weight: 400;\n  font-family: \"Roboto\";\n  font-size: 13px;\n}\n.chat-campaign-name {\n  font-size: 18px !important;\n  font-weight: 500;\n  color: #000000;\n  font-family: \"Roboto\";\n}\n.select-prodcut-sub-text {\n  font-size: 16px;\n  color: #6e6e6e;\n  font-family: \"Roboto\";\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
